export const actionTypes = {
  REQUEST_START: 'AUTHORIZATION.LOGOUT.REQUEST_START',
  SUCCESS: 'AUTHORIZATION.LOGOUT.SUCCESS',
  FAILURE: 'AUTHORIZATION.LOGOUT.FAILURE',
};

export function startRequest() {
  return {
    type: actionTypes.REQUEST_START,
  };
}

export function logoutSuccess() {
  return {
    type: actionTypes.SUCCESS,
  };
}

export function logoutFailure() {
  return {
    type: actionTypes.FAILURE,
  };
}
